module.exports = __webpack_public_path__ + "img/phoenix_kedel_4.10f8e619.png";